export var dataHooks = {
  sliderTextInput: 'slider-text-input',
  sliderTrack: 'slider-track'
};